import { render } from "./HeaderView.vue?vue&type=template&id=9e0c55a6"
import script from "./HeaderView.vue?vue&type=script&lang=js"
export * from "./HeaderView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\chany\\Desktop\\my\\apache\\project\\vue_wage\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__